<div>
  <label *ngIf="showMessage && message">{{ message }}</label>
  <div class="loader">
    <span class="l-1">I</span>
    <span class="l-2">N</span>
    <span class="l-3">S</span>
    <span class="l-4">S</span>
   
  </div>
</div>
